module.exports = __webpack_public_path__ + "static/media/vector.c43f2190.svg";